import React from 'react';
import { Search, Filter } from 'lucide-react';

/**
 * <Toolbar search={search} onSearch={setSearch}
 *          filters={<>...</>}
 *          actions={<button>Export</button>} />
 */
const Toolbar = ({ search, onSearch, placeholder = 'Search…', filters, actions }) => (
    <div className="flex flex-wrap items-center gap-2 mb-4">
        {onSearch && (
            <div className="relative flex-1 min-w-[220px] max-w-xs">
                <Search className="absolute left-3 top-2.5 h-4 w-4 text-neutral-400" />
                <input
                    type="text"
                    value={search || ''}
                    onChange={e => onSearch(e.target.value)}
                    placeholder={placeholder}
                    className="w-full pl-9 pr-3 py-2 text-sm bg-white border border-neutral-200 rounded-lg
                               placeholder:text-neutral-400
                               focus:border-primary-500 focus:ring-2 focus:ring-primary-500/20"
                />
            </div>
        )}
        {filters && <div className="flex flex-wrap items-center gap-2">{filters}</div>}
        <div className="ml-auto flex items-center gap-2">{actions}</div>
    </div>
);

export default Toolbar;
